import * as Entities from '../../constants/entities';
import { getStatusFilterSelectOptions } from '../../utils/statusUtil';

const quickFilters = [
  {
    name: 'jobName',
    searchKey: 'job.jobName',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Project Name',
    idKey: 'jobName',
    labelKey: 'jobName'
  },
  {
    name: 'jobId',
    searchKey: 'job.id',
    data: [],
    selected: [],
    pageInfo: null,
    placeholder: 'Project Number',
    idKey: 'jobId',
    labelKey: 'jobNumber'
  },
  {
    name: 'insuredStatus',
    searchKey: 'status',
    data: getStatusFilterSelectOptions(Entities.Insured),
    selected: [],
    pageInfo: null,
    placeholder: 'Insured Status',
    idKey: 'value',
    labelKey: 'text'
  }
];

export default quickFilters;
